import { Model } from '@nozbe/watermelondb'
import { field, date, writer, json } from '@nozbe/watermelondb/decorators'
import { Q } from '@nozbe/watermelondb';
import { first, set } from '../global/lib/lodash';

export const TaskColumns = [
    { name: 'assessment_id', type: 'number', isOptional: true },
    { name: 'report_section_id', type: 'number', isOptional: true },
    { name: 'checkpoint_id', type: 'number', isOptional: true },
    { name: 'scorecard_score_id', type: 'number', isOptional: true },
    { name: 'sub_score_id', type: 'number', isOptional: true },
    { name: 'realm_id', type: 'string' },
    { name: 'client_id', type: 'string' },
    { name: 'authors', type: 'string', isRel: true },
    { name: 'assignees', type: 'string', isRel: true },
    { name: 'trade_types', type: 'string', isRel: true },
    { name: 'vendor_id', type: 'string' },
    { name: 'name', type: 'string' },
    { name: 'description', type: 'string', isOptional: true },
    { name: 'status', type: 'number' },
    { name: 'due_date', type: 'number', isOptional: true },
    { name: 'meta', type: 'string', isOptional: true, isJson: true },
    { name: 'created_at', type: 'number' },
    { name: 'updated_at', type: 'number' },
    { name: 'deleted_at', type: 'number' }
]

export class Task extends Model {
    static table = 'task'
    
    @field('assessment_id') assessmentId
    @field('report_section_id') reportSectionId
    @field('checkpoint_id') checkpointId
    @field('scorecard_score_id') scorecardScoreId
    @field('sub_score_id') subScoreId
    @field('realm_id') realmId
    @field('client_id') clientId
    @field('authors') authorId
    @field('assignees') assigneesArray
    @field('trade_types') tradeTypesArr
    @field('vendor_id') vendorId
    @field('name') name
    @field('description') description
    @field('status') status
    @date('due_date') dueDate
    @json('meta', j => j) meta
    @date('created_at') createdAt
    @date('updated_at') updatedAt
    @date('deleted_at') deletedAt

    @writer async load(toLoad = 'all') {
        let loaders = [
            { name: 'images', req: async () => (await this.collections.get('media').query(Q.where('model_id', this.id))).map(img => img.toRaw()) },
            { name: 'realm', req: async () => first(await this.collections.get('realm').query(Q.where('id', this.realmId))) },
            { name: 'comments', req: async () => (await this.collections.get('comment').query(Q.where('commentable_id', this.id))).map(c => c.toRaw()) },
            { name: 'authors', req: async () => this.authorId ? await this.collections.get('user').query(Q.where('id', this.authorId)) : [] },
            { name: 'assignees', req: async () => (await Promise.all(this.assigneesArray.split(',').map(async a => first(await this.collections.get('user').query(Q.where('id', a))) ))).filter(f => !!f) },
            { name: 'tradeTypes', req: async () => (await Promise.all(this.tradeTypesArr.split(',').map(async a => first(await this.collections.get('tradeType').query(Q.where('id', a))) ))).filter(f => !!f).map(f => f.toRaw()) },
        ]

        if (Array.isArray(toLoad)) {
            loaders = loaders.filter(f => toLoad.includes(f.name))
        }

        await Promise.all(loaders.map(async l => {
            const res = await l.req();
            set(this, l.name, res);
        }))

        // this.images = (await this.collections
        //     .get('media')
        //     .query(
        //         Q.where('model_id', this.id),
        //     )).map(img => img.toRaw());

        // this.realm = first(await this.collections
        //     .get('realm')
        //     .query(
        //         Q.where('id', this.realmId),
        //     ));

        // this.comments = (await this.collections
        //     .get('comment')
        //     .query(
        //         Q.where('commentable_id', this.id),
        //     )).map(c => c.toRaw());

        // this.authors = this.authorId ? await this.collections
        //     .get('user')
        //     .query(
        //         Q.where('id', this.authorId),
        //     ) : [];

        // this.assignees = (await Promise.all(this.assigneesArray.split(',').map(async a => {
        //     return first(await this.collections.get('user').query(Q.where('id', a)))
        // }))).filter(f => !!f);

        // this.tradeTypes = (await Promise.all(this.tradeTypesArr.split(',').map(async a => {
        //     return first(await this.collections.get('tradeType').query(Q.where('id', a)))
        // }))).filter(f => !!f).map(f => f.toRaw());
    }
}